import { render, staticRenderFns } from "./TeamMain.vue?vue&type=template&id=c0a88064&scoped=true&"
import script from "./TeamMain.vue?vue&type=script&lang=js&"
export * from "./TeamMain.vue?vue&type=script&lang=js&"
import style0 from "./TeamMain.vue?vue&type=style&index=0&id=c0a88064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a88064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0a88064')) {
      api.createRecord('c0a88064', component.options)
    } else {
      api.reload('c0a88064', component.options)
    }
    module.hot.accept("./TeamMain.vue?vue&type=template&id=c0a88064&scoped=true&", function () {
      api.rerender('c0a88064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/Team/TeamMain.vue"
export default component.exports